import { render, staticRenderFns } from "./TeacherAbsent.vue?vue&type=template&id=70be1448"
import script from "./TeacherAbsent.vue?vue&type=script&lang=js"
export * from "./TeacherAbsent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports